import type {Alert} from './types';

export const alert: Alert = {
  clearQueue: () => {},
  confirm: () => Promise.resolve(true),
  error: <T>() => Promise.resolve<T>(undefined as unknown as T),
  getCurrentAlert: () => undefined,
  hide: () => {},
  isShown: false,
  show: <T>() => Promise.resolve<T>(undefined as unknown as T),
  success: <T>() => Promise.resolve<T>(undefined as unknown as T),
  update: () => {},
};
